import { render, staticRenderFns } from "./RevenuesTypeFilter.vue?vue&type=template&id=5616c38b&"
import script from "./RevenuesTypeFilter.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports